import { isFirebaseMessagingConfigured } from "@/lib/firebase/client"
import { revokeFcmToken } from "@/lib/push/messaging"
import { clearDeviceToken } from "@/lib/push/push-api"

/** Clears FCM token locally and on the server (best effort). */
export async function clearPushDeviceOnLogout(): Promise<void> {
  if (!isFirebaseMessagingConfigured()) {
    return
  }
  try {
    await revokeFcmToken()
  } catch {
    // ignore
  }
  try {
    await clearDeviceToken()
  } catch {
    // ignore — token may already be cleared or session ended
  }
}
